import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";

export default function CategoryGrid() {
  return (
    <div className="flex gap-3 overflow-x-auto pb-2 lg:grid lg:grid-cols-4 lg:gap-5 lg:overflow-visible lg:pb-0">
      {categories.map((category) => {
        const count = videos.filter((video) => video.categoryId === category.id).length;
        return (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="group flex min-w-[180px] items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50 lg:min-w-0"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${category.icon} text-xl`}></i>
            </span>
            <div className="min-w-0">
              <h3 className="font-heading text-sm font-semibold text-foreground-950">{category.name}</h3>
              <p className="mt-0.5 truncate text-xs text-foreground-500">{count} 个视频资源</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}